import { AppComponent } from './app.component';

// Angular
import { BrowserModule } from '@angular/platform-browser';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppRoutingModule } from './app-routing.module';
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  provideAppInitializer,
  LOCALE_ID,
  InjectionToken,
} from '@angular/core';

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

//lib
import { PermissionGuard } from '@acpgruppe/essp-ui';
import { AuthGuard, CONFIGURATION } from '@acpgruppe/essp-ui';
import { AuthConfigService } from '@acpgruppe/essp-ui';
import { AppTrackerService } from '@acpgruppe/essp-ui';

import { environment } from '../environments/environment';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TokenInterceptorService } from './token-interceptor-service';
import { appConfig } from 'src/environments/app-config';

import { providePrimeNG } from 'primeng/config';
import { EsspThemeConfiguration } from '@acpgruppe/essp-ui';

export const BASE_PATH = new InjectionToken<string>('basePath');
registerLocaleData(localeDe);

@NgModule({
  declarations: [AppComponent],
  imports: [
    OAuthModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    AuthGuard,
    AuthConfigService,
    PermissionGuard,
    provideAppInitializer(() => {
      inject(AppTrackerService);
    }),

    provideAppInitializer(() => {
      const initializerFn = (
        (initialAuthService: AuthConfigService) => () =>
          initialAuthService.initAuth(environment)
      )(inject(AuthConfigService));
      return initializerFn();
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: EsspThemeConfiguration,
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    { provide: BASE_PATH, useValue: environment.partnernavBackendUrl },
    { provide: CONFIGURATION, useValue: appConfig },
    { provide: LOCALE_ID, useValue: 'de' },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
